"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggerDefaultOptions = void 0;
const consoleColorsDefault = {
    error: 'background-color: #FF0000; color: #FFFFFF', // Bright red for errors
    info: 'background-color: #007BFF; color: #FFFFFF', // Bright blue for info
    log: 'background-color: #28A745; color: #FFFFFF', // Bright green for logs
    trace: 'background-color: #6F42C1; color: #FFFFFF', // Bright purple for trace
    warn: 'background-color: #FFC107; color: #000000', // Bright yellow for warnings
};
exports.loggerDefaultOptions = {
    colors: consoleColorsDefault,
    separator: ':',
    separatorIn: '[',
    separatorOut: ']',
    withColors: true,
};
//# sourceMappingURL=default.js.map